import styled from '@emotion/styled';

interface Props {
  apiKey: string;
  address: string;
  width?: string | number;
  height?: number;
}

export default function Component(props: Props) {
  const width = props.width || 600;
  const height = props.height || 450;
  return (
    <Container
      style={{
        width,
        height,
      }}
    >
      <MapFrame
        width={width}
        height={height}
        src={`https://www.google.com/maps/embed/v1/place?key=${
          props.apiKey
        }&q=${encodeURIComponent(props.address)}`}
      />
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  height: 100%;
`;

const MapFrame = styled.iframe`
  width: 100%;
  height: 100%;
`;
